import { Box, Typography } from '@mui/material';

/** `titleSx`: ajuste opcional do título (ex.: a escala das páginas do Laticínio). */
export default function PageHeader({ title, subtitle, titleSx }) {
    return (
        <Box>
            <Typography
                component="h1"
                sx={{
                    fontWeight: 800,
                    color: 'text.primary',
                    letterSpacing: -0.5,
                    lineHeight: 1.2,
                    fontSize: { xs: '1.35rem', sm: '1.75rem', md: '2.125rem' },
                    ...titleSx,
                }}
            >
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    {subtitle}
                </Typography>
            )}
        </Box>
    );
}
